<template>
  <div>
    <div>
      <section class="boxes select-item-table">
        <div class="index-content centered-block ">
          <b-row class="justify-content-md-center boxes select-item-btn customer-verify variant-selector-container">
            <b-col lg="12" cols="12" class="pl-sm-3 pr-sm-3 pl-0 pr-0">
              <div class="order-it">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th v-for="name of columns" :key="'column-' + name" class="name-column">{{name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}}</th>
                      <th>Quantity</th>
                      <th class="action-column"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row of rows" :key="'row-' + row.id">
                      <td v-for="name of columns" :key="'cell-' + row.id + '-' + name" class="name-column">{{row.options[name]}}</td>
                      <td>
                        <b-form-input
                          type="number"
                          v-model.trim="selectedQuantities[row.id].quantity"
                          min="0"
                          :max="totalQuantity"
                          required
                        ></b-form-input>
                      </td>
                      <td class="action-column">
                        <b-link @click="clearQuantity(row.id)"><font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon></b-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </div>
      </section>
    </div>
    <b-row v-if="showStepLabels" class="justify-content-md-center boxes claim mt-4 variant-btns-wrapper" :class="{'new-btns-container': !activeSession.is_legacy}">
      <b-col md="7" cols="12" :class="{'my-class': !activeSession.is_legacy}">
        <b-row class="choice-fields-btns">
          <b-col v-for="input in activeSession.valid_inputs" :key="'choice-' + input.id" cols="12" class="text-center">
            <button @click="done()"
                    class="btn-base input-choice-btn input-btn"
                    :style="getStyles(input)">
              <div v-html="sessionInputLabel(input)"></div>
            </button>
          </b-col>
          <b-col cols="12" class="back">
            <b-button block @click="goBack()" class="btn-outline-success btn-back stroke" variant="outline-primary">Back</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-else class="justify-content-center boxes select-item-btn customer-verify mt-4 variant-container-btns">
      <b-col v-if="activeSession && activeSession.can_undo" md="4" cols="6" class="back">
        <b-button block @click="goBack()" class="btn-outline-success btn-back stroke" variant="outline-primary">Back</b-button>
      </b-col>
      <b-col :md="activeSession && activeSession.can_undo ? 4 : 8" :cols="activeSession && activeSession.can_undo ? 6 : 12">
        <b-button block @click="done()" class="btn btn-default btn-account font-weight-normal select-item-continue-btn" variant="primary">Continue
          <font-awesome-icon :icon="['fas', 'caret-right']" class="footer_btn"></font-awesome-icon>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {StepCategory} from '@/constants'
import {updateFontSizes} from '@/utils'

export default {
  name: 'VariantQuantities',
  props: {
    selectedQuantities: Object,
    totalQuantity: Number
  },
  data: function() {
    return {
      rows: [],
      columns: []
    }
  },
  computed: {
    ...mapGetters(['activeSession']),
    showStepLabels: function() {
      return this.activeSession && this.activeSession.step_category === StepCategory.ChangeVariant
    }
  },
  methods: {
    done: function() {
      let totalQuantity = 0
      this.$store.commit('clear_messages')

      for (const row of Object.values(this.selectedQuantities)) {
        const quantity = parseInt(row.quantity)
        totalQuantity += isNaN(quantity) ? 0 : quantity
      }

      if (totalQuantity !== this.totalQuantity) {
        this.$store.commit('error', 'Total quantity must be ' + this.totalQuantity.toString())
        return
      }

      this.$emit('select', this.selectedQuantities)
    },
    goBack: function() {
      this.$emit('back') // go back to the previous step (ignore selections)
    },
    clearQuantity: function(variantId) {
      this.selectedQuantities[variantId].quantity = 0
    },
    getStyles: function(input) {
      return input && input.button_styles && input.button_styles.style
    },
    sessionInputLabel(input) {
      if (input) {
        return updateFontSizes(input.formatted_label)
      }
      return null
    }
  },
  created() {
    let rows = []
    const optionNames = {}

    for (const [id, row] of Object.entries(this.selectedQuantities)) {
      row.id = id
      rows.push(row)
      Object.keys(row.options).forEach(name => {
        optionNames[name] = true
      })
    }

    this.rows = rows.sort((a, b) => a.key.localeCompare(b.key))
    this.columns = Object.keys(optionNames).sort()
  }
}
</script>

<style scoped lang="less">
.stroke{
  border: 2px solid;
}

.variant-btns-wrapper {
  .choice-fields-btns {
    margin: 0 auto;
  }

  button,
  .btn-back {
    padding: 12px 16px !important;
    min-height: 44px !important;
    text-transform: none;
  }
  .btn-back {
    padding: 8px 16px !important;
  }
}

</style>
